import * as React from 'react';
import * as TogglePrimitive from '@radix-ui/react-toggle';
import { cn } from '../../lib/utils';
import { toggleVariants } from '../ToggleButton/variants';
import type { ToggleButtonProps } from './types';

export const ToggleButton = React.forwardRef<
  React.ComponentRef<typeof TogglePrimitive.Root>,
  ToggleButtonProps
>(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleVariants({ variant, size, className }), 'eye:button')}
    {...props}
  />
));

ToggleButton.displayName = TogglePrimitive.Root.displayName;
